import { render, staticRenderFns } from "./NsrItemFluctuation.vue?vue&type=template&id=cde3f04a"
import script from "./NsrItemFluctuation.vue?vue&type=script&lang=js"
export * from "./NsrItemFluctuation.vue?vue&type=script&lang=js"
import style0 from "./NsrItemFluctuation.vue?vue&type=style&index=0&id=cde3f04a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports